const language = document.documentElement.lang
const customMessages = language === 'en-US' ? {
  noOfPeople: {},
  householdIncome: {},
  firstName: {},
  lastName: {},
  date: {
    regex: 'Please enter a valid date.'
  },
  phone: {
    minLength: 'You must enter 10 digits.',
    maxLength: 'You must enter 10 digits.',
  },
  email: {
    regex: 'Please enter a valid email address.'
  },
  englishLevel: {},
  zipcode: {
    remoteValidate: 'Enter a valid zip code.'
  },
  inputFile: {},
  employeeName: {},
  employeeIdNumber: {}
} : {
  noOfPeople: {},
  householdIncome: {},
  firstName: {},
  lastName: {},
  date: {
    regex: 'Por favor, escribe una fecha valida.'
  },
  phone: {
    minLength: 'Por favor, no escribas menos de 10 digitos.',
    maxLength: 'Por favor, no escribas mas de 10 digitos.',
  },
  email: {
    regex: 'Por favor, escribe una dirección de correo válida.'
  },
  englishLevel: {},
  zipcode: {
    remoteValidate: 'Por favor, ingresa un código postal válido.'
  },
  inputFile: {},
  employeeName: {},
  employeeIdNumber: {}
}

const validateConfig = [
  {
    elementID: 'noOfPeople',
    rules: {
      required: true
    },
    messages: customMessages.noOfPeople
  },
  {
    elementID: 'householdIncome',
    rules: {
      required: true
    },
    messages: customMessages.householdIncome
  },
  {
    elementID: 'date',
    rules: {
      required: true,
      regex: /^((0?[1-9])|1[012])\/(([0-2][0-9])|([1-9])|(3[0-1]))\/(19|20)[0-9]{2}$/,
      over: 19,
      under: 100
    },
    messages: customMessages.date
  },
  {
    elementID: 'firstName',
    rules: {
      required: true,
      minLength: 2
    },
    messages: customMessages.firstName
  },
  {
    elementID: 'lastName',
    rules: {
      required: true,
      minLength: 2
    },
    messages: customMessages.lastName
  },
  {
    elementID: 'phone',
    rules: {
      required: true,
      minLength: 12,
      maxLength: 12
    },
    messages: customMessages.phone
  },
  {
    elementID: 'email',
    rules: {
      required: true,
      minLength: 3,
      maxLength: 255,
      regex: /^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b$/i
    },
    messages: customMessages.email
  },
  {
    elementID: 'englishLevel',
    rules: {
      required: true
    },
    messages: customMessages.englishLevel
  },
  {
    elementID: 'input-file',
    rules: {
      required: true
    },
    messages: customMessages.inputFile
  },
  {
    elementID: 'employeeName',
    rules: {
      required: true,
      minLength: 2
    },
    messages: customMessages.employeeName
  },
  {
    elementID: 'employeeIdNumber',
    rules: {
      required: true
    },
    messages: customMessages.employeeIdNumber
  },
  {
    elementID: 'zipcode',
    rules: {
      required: true,
      minLength: 3,
      maxLength: 5,
      remoteValidate: {
        url: 'https://www.confiejarvis.com/thor/javascript?zipcode={value}',
        processData: (data) => data === 0
      }
    },
    messages: customMessages.zipcode
  }
]

const { validateForm } = validating(validateConfig)
const forms = document.querySelectorAll('.js-form')
forms.forEach(form => {
  form.noValidate = true
  form.addEventListener('submit', async (e) => {
    e.preventDefault()
    const results = (await Promise.all(validateForm()))

    if (!results.some(item => !item.value)) {
      //Logica de desabilitar boton y loader
      const buttonSubmit = document.querySelector('.js-submit-button')
      buttonSubmit.setAttribute('disabled', true)
      buttonSubmit.style.cursor = 'wait';

      const loaderComponent = document.createElement('div')
      loaderComponent.classList.add('c-hero-form__controls__loader')
      loaderComponent.classList.add('c-hero-quote__controls__loader')
      buttonSubmit.appendChild(loaderComponent)

      const labelForm = document.querySelector('.form-label-error.js-form-error')
      if (labelForm) labelForm.remove()

      grecaptcha.ready(function () {
        grecaptcha.execute('6LfiPNIUAAAAAMRc-uxUCze2sMZnwcaKPrR95mwz', {
          action: 'contact_lp'
        }).then(function (token) {
          var recaptchaResponse = document.getElementById('recaptchaResponse');
          recaptchaResponse.value = token;
          const formData = new FormData(form)

          //Seleccionamos los valores que deseamos (esto debido a que se agregan externamente varios input hidden que no se desea enviar)
          const dataKeyValue = []
          for (const pair of formData.entries()) {
            dataKeyValue.push({ key: pair[0], value: pair[1] })
          };

          //Recogemos la url e integramos el valor de code
          const baseURL = form.action.split('?')[0]
          const baseUrlWithCode = baseURL.replace('%3Ccode%3E', formData.get('code'))

          //Se arma el formData con la estructura deseada
          const newFormData = new FormData()
          dataKeyValue.map(item => newFormData.append(`content[${item.key}]`, item.value))


          fetch(baseUrlWithCode, {
            method: 'POST',
            headers: {
              'Accept': 'application/json'
            },
            body: newFormData
          })
            .then(res => res.json())
            .then(res => {
              loaderComponent.remove()
              if (res.success) {
                const urlOK = document.querySelector("[name='url_ok']")
                window.location.href = urlOK.value
              } else {
                if (res.error) {
                  const urlError = document.querySelector("[name='url_error']")
                  window.location.href = urlError.value
                } else {
                  const labelErrorForm = document.createElement('label')
                  labelErrorForm.classList.add('form-label-error', 'js-form-error')
                  labelErrorForm.textContent = res.message === "" ? 'Oops an unexpected error occurred. Please try again in some minutes' : res.message
                  form.appendChild(labelErrorForm)
                }
              }
            })
            .catch(err => {
              const labelErrorForm = document.createElement('label')
              labelErrorForm.classList.add('form-label-error', 'js-form-error')
              labelErrorForm.textContent = 'Oops an unexpected error occurred. Please try again in some minutes'
              form.appendChild(labelErrorForm)
            })
        });
      });
    } else {
      for (item of results) {
        if (!item.value) {
          item.element.focus()
          break
        }
      }
    }
  })
})